export const SENTRY_VIEWER_SCRIPT_DSN = 'https://f59cf9e3798d4c87a7ad84ca11b8f31a@sentry.wixpress.com/693';
export const SENTRY_COMPONENT_SCRIPT_DSN = 'https://c9bdeb1ef4594bce927a38251efaac47@sentry.wixpress.com/694';
//# sourceMappingURL=sentry-dsn.js.map